export const GET_INTERVIEW_CONFIG_API_HTTP_STATUS_CODES = [
  400, 401, 403, 404, 422, 500, 502, 503, 504,
];

export const GET_INTERVIEW_CONFIG_ERROR_MESSAGE =
  "Failed to load company configuration. Please refresh and try again.";
